import { connect, mapProps } from '@formily/vue'
import LabelsCardView from './LabelsCard.vue'

const LabelsCard = connect(LabelsCardView, mapProps({ readOnly: 'readonly' }))

export default LabelsCard
